import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Language} from '../../../../common/models/language';
import {MainMenuSection} from '../../../../common/models/main-menu-section';
import {EsuvoOptionService} from '../../../shared/services/esuvo-option.service';
import {Utils} from '../../../../common/services/Utils';
import {CommonService} from '../../../shared/services/common.service';
import {Principal} from '../../../../common/services/principal';
import {PersonType} from '../../../../common/enums/person-type.enum';
import {AuthService} from '../../../../common/services/auth.service';
import {TechSupportService} from '../../../shared/services/tech-support.service';
import {Router} from '@angular/router';

declare const $: any;

@Component({
  selector: 'app-common-main-layout',
  templateUrl: './common-main-layout.component.html',
  styleUrls: ['./common-main-layout.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class CommonMainLayoutComponent implements OnInit {

  menuSectionList: MainMenuSection[] = [];
  languages = [];
  logoPath = 'assets/images/pem_logo.png';
  logoMiniPath = `assets/images/logos/${window.location.hostname}/pem_logo_footer.png`;
  domain = 'www.platonus.kz';
  currentLanguage: Language;
  langID: number;
  footerDto: any;
  routerLink = '/login';
  routerLinkTitle = 'Enter';
  isAuthorized = false;
  topLinkClass = '';
  showTechSupportLink = false;
  searchText = '';

  constructor(private _commonService: CommonService,
              private _translateService: TranslateService,
              private _utils: Utils,
              private _footerService: EsuvoOptionService,
              private _principal: Principal,
              private techService: TechSupportService,
              private _authService: AuthService,
              private router: Router) {
    this._principal.reloadUserData();
  }

  ngOnInit() {
    this.langID = Language.getCurrentLanguage().id;
    this.languages = Language.languages;
    this.currentLanguage = Language.getCurrentLanguage();
    this.initializeMainMenu();
    this.initializeFooter();
    this.initializeAdminPanelLink(true);
    this.getTechSupportData();
  }

  getTechSupportData() {
    this.techService.getAdminData().subscribe(
      res => {
        if (res) {
          this.showTechSupportLink = res.showLink;
        }
      }
    );
  }

  public initializeAdminPanelLink(self) {
    const routArr = [];
    if (self && this._principal.isLoggedIn()) {
      if (this._principal.isAdmin() || this._principal.isRegionAdmin()) {
        routArr.push('/admin', 'admin_panel');
      } else if (this._principal.isModerator()) {
        routArr.push('/moderator', 'moderator_panel');
      } else if (this._principal.isEnroll()) {
        routArr.push('/enroll/main', 'user_panel');
      } else if (this._principal.isUser()) {
        routArr.push('/user', 'user_panel');
      }
    } else {
      routArr.push('/login', 'Enter');
    }
    this.isAuthorized = routArr[0] !== '/login';
    this.routerLink = routArr[0];
    this.routerLinkTitle = routArr[1];
  }

  initializeMainMenu() {
    this._commonService.getMenuSectionList().subscribe(data => {
        if (data) {
          this.menuSectionList = this.translateList(data);
          this.calcSectionsDepth(this.menuSectionList, 0);
          this.processModeratorsUsers(this.menuSectionList);
        }
      }
    );
  }

  calcSectionsDepth(menuSectionList: MainMenuSection[], depthStep: number) {
    depthStep++;
    for (let i = 0; i < menuSectionList.length; i++) {
      menuSectionList[i].depth = 0;
      menuSectionList[i].depth += depthStep;
      if (menuSectionList[i].subSectionList) {
        this.calcSectionsDepth(menuSectionList[i].subSectionList, depthStep);
      }
    }
  }

  processModeratorsUsers(menuSectionList: MainMenuSection[]) {
    for (let i = 0; i < menuSectionList.length; i++) {
      if (menuSectionList[i].depth === 1) {// первый уровень менюшки
        if (menuSectionList[i].moderatorsList && menuSectionList[i].subSectionList) {
          for (let iSub = 0; iSub < menuSectionList[i].subSectionList.length; iSub++) {
            for (let iMod = 0; iMod < menuSectionList[i].moderatorsList.length; iMod++) {
              if (menuSectionList[i].subSectionList[iSub].moderatorsList.indexOf(menuSectionList[i].moderatorsList[iMod]) === -1 &&
                  menuSectionList[i].moderatorsList[iMod].subSectionId === null) {
                menuSectionList[i].subSectionList[iSub].moderatorsList.push(menuSectionList[i].moderatorsList[iMod]);
              }
            }
          }
        }
      }
    }
  }

  initializeFooter() {
    if (this.footerDto) {
      this.footerDto.about = this._utils.getMultiValue(this.footerDto, 'about');
      return;
    }
    this._footerService.getFooter().subscribe(data => {
      if (data) {
        data.about = this._utils.getMultiValue(data, 'about');
      }
      this.footerDto = data;
    });
  }

  changeLanguage(languageCode): void {
    localStorage.setItem(Language.SYSTEM_LANGUAGE_CODE_LABEL, languageCode);
    this._translateService.setDefaultLang(languageCode);
    this._translateService.use(languageCode);
    this.currentLanguage = Language.getLangObject(languageCode);
    this.langID = Language.getLangID(languageCode);
    this.menuSectionList = this.translateList(this.menuSectionList);
    this.initializeFooter();
  }

  private translateList(list) {
    const result = [];
    if (list && list.length) {
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (e.enable) {
          e.name = this._utils.getMultiValue(e, 'name');
          if (e.subSectionList && e.subSectionList.length) {
            e.subSectionList = this.translateList(e.subSectionList);
          }
          result.push(e);
        }
      }
    }
    return result;
  }

  onLogout() {
    this._authService.logout(PersonType.USER);
    this.initializeAdminPanelLink(false);
  }

  toTop() {
    $('body,html').animate({
      scrollTop: 0
    }, 600);
    this.topLinkClass = $(window).scrollTop() > 150 ? 'visible' : '';

/*
    $(window).scroll(function () {
      if ($(window).scrollTop() > 150) {
        $('#backtotop').addClass('visible');
      } else {
        $('#backtotop').removeClass('visible');
      }
    });
*/
  }

  goToSearchPage() {
    if(this.searchText) {
      this.router.navigate(['/search/', this.searchText]);
      this.searchText = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/common-main-layout/common-main-layout.component.ts